module.exports = __webpack_public_path__ + "static/media/icon-arrow-prev.ec3c7dc9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-arrow-prev.svg
// module id = 1264
// module chunks = 19